import { useQuery } from '@tanstack/react-query'

import { analyticsApi, DateRangeParams } from '@services/analytics.service'

export function useAnalyticsOverview(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'overview', params],
    staleTime: 5 * 60 * 1000, // 5 minutes
    queryFn: () => analyticsApi.getOverview(params),
  })
}

export function useKPISummary(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'kpi', params],
    staleTime: 5 * 60 * 1000,
    queryFn: () => analyticsApi.getKPISummary(params),
  })
}

export function useAppointmentAnalytics(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'appointments', params],
    staleTime: 5 * 60 * 1000,
    queryFn: () => analyticsApi.getAppointmentAnalytics(params),
  })
}

export function useRevenueAnalytics(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'revenue', params],
    staleTime: 5 * 60 * 1000,
    queryFn: () => analyticsApi.getRevenueAnalytics(params),
  })
}

export function usePatientAnalytics(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'patients', params],
    staleTime: 5 * 60 * 1000,
    queryFn: () => analyticsApi.getPatientAnalytics(params),
  })
}

export function useDepartmentComparison(params?: DateRangeParams) {
  return useQuery({
    queryKey: ['analytics', 'departments', params],
    staleTime: 5 * 60 * 1000,
    queryFn: () => analyticsApi.getDepartmentComparison(params),
  })
}
